import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

/**
 * Reusable header component for grid sections
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The main title text
 * @param {string} props.description - The description text
 * @returns {JSX.Element} Header stack with title and description
 */
function GridHeader({ title, description }) {
  return (
    <Stack
      sx={{
        alignItems: 'flex-start',
        mb: 3,
        textAlign: 'left',
        width: '100%',
      }}
    >
      <Typography
        sx={{
          fontWeight: 'bold',
          lineHeight: 1.2,
          mb: 1,
          textAlign: 'left',
          width: '100%',
        }}
        variant="h5"
      >
        {title}
      </Typography>
      <Typography
        color="text.secondary"
        sx={{
          lineHeight: 1.5,
          textAlign: 'left',
          width: '100%',
        }}
        variant="body1"
      >
        {description}
      </Typography>
    </Stack>
  );
}

GridHeader.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default GridHeader;
